import BaseService from "./geral/BaseService";

const ConsVesselVisit = "VesselVisit";
const base = "EntradaAntecipada";


export default class EntradaAntecipadaService extends BaseService {
    constructor() {
        super(base);
    }

    NovaSolicitacao(solicitacao){
        return super.httpPost(`/${base}/NovaSolicitacao`, solicitacao)
    };
    
    BuscarSolicitacoes(booking = "", vesselVisit = "", container = ""){
        console.log(booking, container, vesselVisit)
        return super.httpGet(`/${base}/ListarSolicitacoes?booking=${booking}&container=${container}&vesselVisit=${vesselVisit}`)
    };
    SituacaoEntradaAntecipada(){
        return super.httpGet(`/${base}/SituacaoEntradaAntecipada`)
    };
    VerificarTermo(){
        return super.httpGet(`/${base}/VerificarTermo`)
    };
    PostTermo(){
        return super.httpPost(`/${base}/TermoAceito`)
    };
    PostInativar(solicitacao){
        return super.httpPost(`/${base}/InativarSolicitacao`, solicitacao)
    };
};
    


// WEBPACK FOOTER //
// ./src/services/EntradaAntecipadaService.js